import { Component, Renderer2, inject, ElementRef, HostListener } from '@angular/core';
import { Cookies } from 'src/app/lib/cookies';
import { AuthService } from 'src/app/services/auth.service';
import { UserFacade } from '../../store/user';
import { UserSettingFacade } from 'src/app/store/usersetting';
import { UserService } from 'src/app/services/user.service';
import { AuthFacade } from 'src/app/store/auth/auth.facade';
declare var $: any;
interface Profile {
  firstName: string;
  lastName: string;
  email: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  profileDetails: Profile = {
    firstName: '',
    lastName: '',
    email: ''
  };
  theme = ''
  loggedIn: boolean = false
  siteSetting: any = {};
  dropdownVisible=false;

  private readonly userFacade: UserFacade = inject(UserFacade);
  notifications: any;
  auth: any;
  dropdownVisibleblog= false;
  constructor(
    private cookie: Cookies,
    private renderer: Renderer2,
    private service: AuthService,
    private userSettingFacade: UserSettingFacade,
    private elementRef: ElementRef,
    private userService :UserService,
        private authFacade :AuthFacade


  ) {
    if (this.cookie.isLogin()) {
      this.loggedIn = true
    }
    this.getprofile()
    this.getUserSetting();
    this.getNotification();

      this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    })
  
  }
getNotification(): void {
  if(!this.auth){
  this.userService.getMaintenenceNotification().subscribe({
    next: (res: any) => {
      if (res.success && Array.isArray(res.result)) {
        // Find the first notification with status "active"
        const activeNotif = res.result.find((notif: any) => notif.status === 'active');
        this.notifications = activeNotif ? activeNotif.title : '';
        console.log('Active notification title:', this.notifications);
      } else {
        this.notifications = '';
      }
    }, 
    error: (err: any) => {
      console.error(err);
      this.notifications = '';
    }
  });
  }

}


  onClickToggleClass() {
    this.renderer.addClass(document.body, 'light_theme');
  }

  signOut(): void {
    this.service.logoutApi()
  }

  getprofile() {
    this.userFacade.user$
      .subscribe({
        next: (data: any) => {
          this.profileDetails.email = data.email
          this.profileDetails.firstName = data.firstName
          this.profileDetails.lastName = data.lastName
        },

        complete: () => { }
      })
  }

  getUserSetting() {
    this.userSettingFacade.usersetting$
      .subscribe({
        next: (v: any) => {
          this.theme = v.defaultTheme
          if (v.siteSetting) {
            this.siteSetting = v.siteSetting
          }
        },
        error: () => { }
      })
  }

  ngAfterViewInit() {
    // Use jQuery to handle the click event
    $(this.elementRef.nativeElement).find('.header__btn').click(() => {
      // console.log('Button clicked using jQuery!');
      $(this.elementRef.nativeElement).toggleClass("header__btn--active");
      $(".header").toggleClass("header--active");
      $(".sidebar").toggleClass("sidebar--active");
      $(".home_menu_bar").toggleClass("sidebar--active");
    });
  }

  
  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    // Check if the clicked target is inside the dropdown
    const clickedInside = (event.target as HTMLElement).closest('.drop-when-ever-up-menu');

    // If the click is outside the dropdown and the dropdown is visible, close it
    if (!clickedInside && this.dropdownVisible) {
      this.hideDropdown1();
    }
        if (!clickedInside && this.dropdownVisibleblog) {
      this.hideDropdown1blog();
    }
  }

  // Prevent click event from closing the dropdown when clicking inside the dropdown

  @HostListener('click', ['$event'])
  onDropdownClick(event: MouseEvent): void {
    event.stopPropagation();  // Prevent click event from propagating to document
  }



  showDropdown() {
    this.dropdownVisible = true;
  }
  
  showDropdownblog() {
    this.dropdownVisibleblog = true;
  }

  hideDropdown() {
    // setTimeout(() => {
    //   this.dropdownVisible = false;
    // }, 2000); 

  }
  
  hideDropdown1() {
  
    this.dropdownVisible = false;
 
}


hideDropdown1blog(){
   setTimeout(() => {
    this.dropdownVisibleblog = false;
    }, 2000); 
  }
}
